import { createAction } from "redux-actions";
import { GET_SIIM } from "../constants";
import { feathersCreateData } from "../services";

// export const transferRequest = createAction(TRANSFER_REQUEST, (data) => serverTransferRequest(urlTransferCodes, data)())
export const getSiim = createAction(GET_SIIM, () => feathersCreateData('core-server',{
    service: 'COLLECTIONS_SIIM',
    func: 'GET_SIIM'
})())
